import React from 'react';

interface LogoImageProps {
  linkAriaLabel?: string;
}

const LogoImage = ({ linkAriaLabel }: LogoImageProps = {}) => {
  return (
    <img
      src="/seniorthrive-full-logo.svg?v=5"
      alt="SeniorThrive"
      className="h-16 w-auto group-transition-transform duration-300"
      loading="eager"
      onError={(e) => {
        e.currentTarget.style.display = 'none';
      }}
    />
  );
};

export default LogoImage;